// @flow
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { Cup as CupIcon } from "../Icons/Tournaments";
import { ActiveTournament } from "../Tournaments/Api";

import type { MapStateToProps } from "react-redux";
import type { State as ReduxState } from "../../redux/reducer";

const Div = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-grow: 1;
  flex-shrink: 1;
  align-self: stretch;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-weight: 300;
  color: ${props => props.theme.ticksFontColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.1;
`;

const Watermark = styled(Div)`
  font-size: ${props => props.size || 150}px;
  letter-spacing: 5px;

  ${props =>
    props.mobile &&
    css`
      font-size: 92.5px;
      letter-spacing: 2px;
      text-size-adjust: 100%;

      @media (max-width: 578px) {
        font-size: 75px;
      }

      @media (max-width: 320px) {
        font-size: 60px;
      }
    `};
`;

const Stock = styled.span``;

const Title = styled.span`
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TournamentWatermark = styled(Div)`
  font-size: 70px;

  @media (max-width: 959px) {
    font-size: 42px;
  }

  ${Stock}, ${Title} {
    margin-top: 0.715em;

    @media (max-width: 959px) {
      margin-top: 0.25em;
    }
  }
`;

type Props = {
  active_tournament: any,
  tradeMode: "tournament" | "binary",
  mobile?: boolean,
  children: React.Node
};

function ActiveStock({
  mobile,
  children,
  tradeMode,
  active_tournament
}: Props) {
  if (
    tradeMode === "tournament" &&
    (active_tournament != null && active_tournament.value != null)
  ) {
    const tournament = active_tournament.value;

    return (
      <TournamentWatermark mobile={mobile}>
        <CupIcon width="48px" />
        <Title>{tournament.title}</Title>
        <Stock>{children}</Stock>
      </TournamentWatermark>
    );
  }

  return (
    <Watermark mobile={mobile}>
      <Stock>{children}</Stock>
    </Watermark>
  );
}

const mapStateToProps = (state: ReduxState) => ({
  tradeMode: state.settings.mode
});

export default connect((mapStateToProps: MapStateToProps<*, *, *>))(props => (
  <ActiveTournament>
    {active_tournament => (
      <ActiveStock active_tournament={active_tournament} {...props} />
    )}
  </ActiveTournament>
));



// WEBPACK FOOTER //
// ./src/components/Chart/ActiveStock.js